import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'rt-tabs',
  templateUrl: './tabs.component.html',
  styleUrls: ['./tabs.component.less'],
  host: {
    '[class.has-bottom-separator]': 'hasBottomSeparator()',
  },
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true,
})
export class TabsComponent {
  public readonly hasBottomSeparator = input<boolean>(true);
}
